import { Injectable } from '@angular/core';
import { PlessViewUtilsSub } from './pless-view-utils-sub.service';
import { PlessResponder } from '../../shared/http/pless-responder.service';
import { PlessHttp } from '../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from './pless-dialog-service-sub';
import { PlessAlert } from '../../shared/pless-alert/pless-alert.component';

/**
 * APIと通信する際に使用するResponderの拡張クラス
 * APIと通信するサービスは基本的にこのクラスを継承する
 */
@Injectable()
export class PlessResponderSub extends PlessResponder {

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * StatusがOK以外の場合の処理
   * 独自のステータス処理を実装したい場合はこのメソッドをオーバーライドする
   *
   * @param status statauタグの値
   * @param result レスポンスの内容(rspタグの値)
   */
  protected statusError(status: string, result: any) {
    if (status === 'plesserror') {
      this.plessErrorHandler(result);
    } else if (status === 'systemerror') {
      this.systemErrorHandler(result);
    } else if (status === 'lockfailer') {
      this.lockErrorHandler(result);
    } else {
      super.statusError(status, result);
    }
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  plessErrorHandler(errList: any): void {
    // エラーコード
    const errCode: string = errList.errorcode[0];
    // 引数
    const msgArray: Array<string> = errList.strings[0].arg;
    if (errCode === 'S0103') {
      this.dialogService.openAlertGetMessage(errCode, msgArray, () => {
        window.location.reload();
      });
      return;
    }
    // エラーメッセージ表示
    this.dialogService.openAlertGetMessage(errCode, msgArray);
  }

  /**
   * システムエラー時のメソッド
   * @param data サーバ受信データ
   *  機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public systemErrorHandler(data: any): void {
    this.dialogService.openAlert(this.makeSystemErrMsg(data), 'E');
  }

  /**
   * システムエラー発生時に表示するメッセージを構築する
   * @param errRsp サーバから受信したエラーレスポンスデータ
   * @return 表示メッセージ
   *
   */
  private makeSystemErrMsg(errRsp: any): string {
    let errMsg: string = <string>'';
    if (errRsp.errorcode != null && errRsp.message != null) {
      errMsg += errMsg + errRsp.errorcode + ' ' + errRsp.message;
    }
    return errMsg;
  }

  /**
   * ロックできなかったレコードがあった場合の処理
   *
   * @param {*} result
   * @memberof PlessResponderSub
   */
  public lockErrorHandler(result: any): void {
    this.dialogService.openAlert('データのロックに失敗しました', 'E');
  }

  /**
   * XMLのタグ内で使用できない文字をエスケープする
   * 値がnull/undefinedの場合、空文字に変換する。
   *
   * @param value エスケープ対象文字列
   */
  protected escapeXML(value: any): string {
    return PlessViewUtilsSub.escapeXML(PlessViewUtilsSub.nullToBlank(value));
  }
}
